module.exports = __webpack_public_path__ + "img/box6-25.d4ee823f.png";